import { z } from "zod";
export const DEFAULT_PASSWORD_MIN_LENGTH = 12;
export const passwordErrorMsg = {
    contextSpecific: 'Avoid context-specific words (eg. username, email)',
    minLength: (n)=>`Have at least ${n} characters`,
    obvious: 'Avoid obvious and simple english words',
    oneNumber: 'Have at least 1 Number',
    oneSpecialCharacter: 'Have at least 1 Special Character',
    repeatingChars: 'Avoid repetitive characters (eg. aaaa, 1234, aaaa4321)',
    required: 'Required'
};
export const invalidPasswords = {
    alphaRepeats: [
        'abcd',
        'dcba',
        'bcde',
        'edcb',
        'cdef',
        'fedc',
        'defg',
        'gfed',
        'efgh',
        'hgfe',
        'fghi',
        'ihgf',
        'ghij',
        'jihg',
        'hijk',
        'kjih',
        'ijkl',
        'lkji',
        'jklm',
        'mlkj',
        'klmn',
        'nmlk',
        'lmno',
        'onml',
        'mnop',
        'ponm',
        'nopq',
        'qpon',
        'opqr',
        'rqpo',
        'pqrs',
        'srqp',
        'qrst',
        'tsrq',
        'rstu',
        'utsr',
        'stuv',
        'vuts',
        'tuvw',
        'wvut',
        'uvwx',
        'xwvu',
        'vwxy',
        'yxwv',
        'wxyz',
        'zyxw'
    ],
    numRepeats: [
        '0123',
        '3210',
        '1234',
        '4321',
        '2345',
        '5432',
        '3456',
        '6543',
        '4567',
        '7654',
        '5678',
        '8765',
        '6789',
        '9876'
    ],
    obvious: [
        'african',
        'american',
        'british',
        'canadian',
        'catholic',
        'chinese',
        'christian',
        'christianity',
        'christmas',
        'congress',
        'democrat',
        'english',
        'european',
        'french',
        'german',
        'hispanic',
        'indian',
        'internet',
        'islamic',
        'israeli',
        'italian',
        'japanese',
        'jewish',
        'korean',
        'mexican',
        'muslim',
        'olympic',
        'olympics',
        'palestinian',
        'persian',
        'republican',
        'russian',
        'senate',
        'soviet',
        'spanish',
        'supreme',
        't-shirt',
        'thanksgiving',
        'united',
        'abandon',
        'ability',
        'abortion',
        'abroad',
        'absence',
        'absolute',
        'absolutely',
        'absorb',
        'abstract',
        'academic',
        'accelerate',
        'accent',
        'accept',
        'acceptable',
        'acceptance',
        'access',
        'accessible',
        'accident',
        'accommodate',
        'accompany',
        'accomplish',
        'accomplishment',
        'according',
        'account',
        'accountability',
        'accounting',
        'accuracy',
        'accurate',
        'accurately',
        'accusation',
        'accuse',
        'achieve',
        'achievement',
        'acknowledge',
        'acquire',
        'acquisition',
        'across',
        'action',
        'active',
        'actively',
        'activist',
        'activity',
        'actress',
        'actual',
        'actually',
        'addition',
        'additional',
        'address',
        'adequate',
        'adjust',
        'adjustment',
        'administer',
        'administration',
        'administrative',
        'administrator',
        'admire',
        'admission',
        'adolescent',
        'adoption',
        'advance',
        'advanced',
        'advantage',
        'adventure',
        'advertising',
        'advice',
        'advise',
        'adviser',
        'advocate',
        'aesthetic',
        'affair',
        'affect',
        'afford',
        'afraid',
        'afternoon',
        'afterward',
        'against',
        'agency',
        'agenda',
        'aggression',
        'aggressive',
        'agreement',
        'agricultural',
        'agriculture',
        'aircraft',
        'airline',
        'airplane',
        'airport',
        'alcohol',
        'allegation',
        'alleged',
        'allegedly',
        'alliance',
        'almost',
        'alongside',
        'already',
        'alternative',
        'although',
        'altogether',
        'aluminum',
        'always',
        'amazing',
        'ambassador',
        'ambition',
        'ambitious',
        'amendment',
        'amount',
        'analysis',
        'analyst',
        'analyze',
        'ancestor',
        'ancient',
        'and/or',
        'animal',
        'anniversary',
        'announce',
        'announcement',
        'annual',
        'annually',
        'anonymous',
        'another',
        'answer',
        'anticipate',
        'anxiety',
        'anxious',
        'anybody',
        'anymore',
        'anyone',
        'anything',
        'anyway',
        'anywhere',
        'apartment',
        'apologize',
        'apparent',
        'apparently',
        'appeal',
        'appear',
        'appearance',
        'application',
        'appoint',
        'appointment',
        'appreciate',
        'appreciation',
        'approach',
        'appropriate',
        'approval',
        'approve',
        'approximately',
        'architect',
        'architecture',
        'argument',
        'around',
        'arrange',
        'arrangement',
        'arrest',
        'arrival',
        'arrive',
        'article',
        'articulate',
        'artifact',
        'artificial',
        'artist',
        'artistic',
        'asleep',
        'aspect',
        'assault',
        'assemble',
        'assembly',
        'assert',
        'assess',
        'assessment',
        'assign',
        'assignment',
        'assist',
        'assistance',
        'assistant',
        'associate',
        'associated',
        'association',
        'assume',
        'assumption',
        'assure',
        'astronomer',
        'athlete',
        'athletic',
        'atmosphere',
        'attach',
        'attack',
        'attempt',
        'attend',
        'attendance',
        'attention',
        'attitude',
        'attorney',
        'attract',
        'attraction',
        'attractive',
        'attribute',
        'auction',
        'audience',
        'author',
        'authority',
        'authorize',
        'automatic',
        'automatically',
        'automobile',
        'autonomy',
        'availability',
        'available',
        'average',
        'awareness',
        'background',
        'backyard',
        'bacteria',
        'balance',
        'balanced',
        'balloon',
        'ballot',
        'banana',
        'banker',
        'banking',
        'barely',
        'barrel',
        'barrier',
        'baseball',
        'basement',
        'basically',
        'basket',
        'basketball',
        'bathroom',
        'battery',
        'battle',
        'beautiful',
        'beauty',
        'because',
        'become',
        'bedroom',
        'before',
        'beginning',
        'behalf',
        'behave',
        'behavior',
        'behavioral',
        'behind',
        'belief',
        'believe',
        'belong',
        'beneath',
        'benefit',
        'beside',
        'besides',
        'better',
        'between',
        'beyond',
        'bicycle',
        'billion',
        'biography',
        'biological',
        'biology',
        'birthday',
        'bishop',
        'bitter',
        'blanket',
        'blessing',
        'bloody',
        'bombing',
        'border',
        'boring',
        'borrow',
        'bother',
        'bottle',
        'bottom',
        'bounce',
        'boundary',
        'boyfriend',
        'branch',
        'breakfast',
        'breast',
        'breath',
        'breathe',
        'breathing',
        'breeze',
        'bridge',
        'briefly',
        'bright',
        'brilliant',
        'broadcast',
        'broken',
        'broker',
        'bronze',
        'brother',
        'brutal',
        'bubble',
        'bucket',
        'budget',
        'builder',
        'building',
        'bullet',
        'burden',
        'bureau',
        'burning',
        'business',
        'businessman',
        'butter',
        'butterfly',
        'button',
        'cabinet',
        'calculate',
        'calculation',
        'calendar',
        'camera',
        'campaign',
        'campus',
        'cancel',
        'cancer',
        'candidate',
        'candle',
        'canvas',
        'capability',
        'capable',
        'capacity',
        'capital',
        'captain',
        'capture',
        'carbohydrate',
        'carbon',
        'career',
        'careful',
        'carefully',
        'carpet',
        'carrier',
        'carrot',
        'cartoon',
        'casino',
        'casual',
        'casualty',
        'catalog',
        'category',
        'cattle',
        'ceiling',
        'celebrate',
        'celebration',
        'celebrity',
        'cemetery',
        'center',
        'central',
        'century',
        'ceremony',
        'certain',
        'certainly',
        'chairman',
        'challenge',
        'chamber',
        'champion',
        'championship',
        'chance',
        'change',
        'changing',
        'channel',
        'chapter',
        'character',
        'characteristic',
        'characterize',
        'charge',
        'charity',
        'charter',
        'cheese',
        'chemical',
        'chemistry',
        'chicken',
        'childhood',
        'chocolate',
        'choice',
        'cholesterol',
        'choose',
        'chronic',
        'church',
        'cigarette',
        'circle',
        'circuit',
        'circumstance',
        'citizen',
        'citizenship',
        'civilian',
        'civilization',
        'classic',
        'classical',
        'classify',
        'classroom',
        'clearly',
        'client',
        'climate',
        'clinic',
        'clinical',
        'closed',
        'closely',
        'closer',
        'closest',
        'closet',
        'clothes',
        'clothing',
        'cluster',
        'coalition',
        'coastal',
        'cocaine',
        'coffee',
        'cognitive',
        'collaboration',
        'collapse',
        'collar',
        'colleague',
        'collect',
        'collection',
        'collective',
        'collector',
        'college',
        'colonial',
        'colony',
        'colorful',
        'column',
        'columnist',
        'combat',
        'combination',
        'combine',
        'combined',
        'comedy',
        'comfort',
        'comfortable',
        'coming',
        'command',
        'commander',
        'comment',
        'commercial',
        'commission',
        'commissioner',
        'commit',
        'commitment',
        'committee',
        'commodity',
        'common',
        'commonly',
        'communicate',
        'communication',
        'community',
        'companion',
        'company',
        'comparable',
        'compare',
        'comparison',
        'compel',
        'compelling',
        'compensation',
        'compete',
        'competition',
        'competitive',
        'competitor',
        'complain',
        'complaint',
        'complete',
        'completely',
        'complex',
        'complexity',
        'compliance',
        'complicated',
        'comply',
        'component',
        'compose',
        'composition',
        'compound',
        'comprehensive',
        'comprise',
        'compromise',
        'computer',
        'concede',
        'conceive',
        'concentrate',
        'concentration',
        'concept',
        'conception',
        'concern',
        'concerned',
        'concerning',
        'concert',
        'conclude',
        'conclusion',
        'concrete',
        'condemn',
        'condition',
        'conduct',
        'conference',
        'confess',
        'confession',
        'confidence',
        'confident',
        'confirm',
        'conflict',
        'confront',
        'confrontation',
        'confuse',
        'confusion',
        'congressional',
        'connect',
        'connection',
        'conscience',
        'conscious',
        'consciousness',
        'consecutive',
        'consensus',
        'consent',
        'consequence',
        'consequently',
        'conservation',
        'conservative',
        'consider',
        'considerable',
        'considerably',
        'consideration',
        'consist',
        'consistent',
        'consistently',
        'conspiracy',
        'constant',
        'constantly',
        'constitute',
        'constitution',
        'constitutional',
        'constraint',
        'construct',
        'construction',
        'consult',
        'consultant',
        'consume',
        'consumer',
        'consumption',
        'contact',
        'contain',
        'container',
        'contemplate',
        'contemporary',
        'contend',
        'content',
        'contest',
        'context',
        'continent',
        'continue',
        'continued',
        'continuing',
        'continuous',
        'contract',
        'contractor',
        'contrast',
        'contribute',
        'contribution',
        'contributor',
        'control',
        'controversial',
        'controversy',
        'convenience',
        'convention',
        'conventional',
        'conversation',
        'conversion',
        'convert',
        'convey',
        'convict',
        'conviction',
        'convince',
        'convinced',
        'cookie',
        'cooking',
        'cooperate',
        'cooperation',
        'cooperative',
        'coordinate',
        'coordinator',
        'corner',
        'corporate',
        'corporation',
        'correct',
        'correctly',
        'correlation',
        'correspondent',
        'corridor',
        'corruption',
        'costly',
        'costume',
        'cottage',
        'cotton',
        'council',
        'counsel',
        'counseling',
        'counselor',
        'counter',
        'counterpart',
        'country',
        'county',
        'couple',
        'courage',
        'course',
        'courtroom',
        'cousin',
        'coverage',
        'create',
        'creation',
        'creative',
        'creativity',
        'creature',
        'credibility',
        'credit',
        'criminal',
        'crisis',
        'criteria',
        'critic',
        'critical',
        'criticism',
        'criticize',
        'crowded',
        'crucial',
        'cruise',
        'crystal',
        'cultural',
        'culture',
        'curiosity',
        'curious',
        'currency',
        'current',
        'currently',
        'curriculum',
        'curtain',
        'custody',
        'custom',
        'customer',
        'damage',
        'dancer',
        'dancing',
        'danger',
        'dangerous',
        'darkness',
        'database',
        'daughter',
        'deadline',
        'deadly',
        'dealer',
        'debate',
        'debris',
        'decade',
        'decent',
        'decide',
        'decision',
        'declare',
        'decline',
        'decorate',
        'decrease',
        'dedicate',
        'deeply',
        'defeat',
        'defend',
        'defendant',
        'defender',
        'defense',
        'defensive',
        'deficit',
        'define',
        'definitely',
        'definition',
        'degree',
        'deliberately',
        'delicate',
        'delight',
        'deliver',
        'delivery',
        'demand',
        'democracy',
        'democratic',
        'demographic',
        'demonstrate',
        'demonstration',
        'denial',
        'density',
        'depart',
        'department',
        'departure',
        'depend',
        'dependent',
        'depending',
        'depict',
        'deploy',
        'deposit',
        'depressed',
        'depression',
        'deputy',
        'derive',
        'descend',
        'describe',
        'description',
        'desert',
        'deserve',
        'design',
        'designer',
        'desire',
        'desperate',
        'desperately',
        'despite',
        'dessert',
        'destination',
        'destroy',
        'destruction',
        'detail',
        'detailed',
        'detect',
        'detective',
        'determination',
        'determine',
        'devastating',
        'develop',
        'developer',
        'developing',
        'development',
        'developmental',
        'device',
        'devote',
        'diabetes',
        'diagnose',
        'diagnosis',
        'dialogue',
        'diamond',
        'dictate',
        'differ',
        'difference',
        'different',
        'differently',
        'difficult',
        'difficulty',
        'digital',
        'dignity',
        'dilemma',
        'dimension',
        'diminish',
        'dining',
        'dinner',
        'diplomat',
        'diplomatic',
        'direct',
        'direction',
        'directly',
        'director',
        'disability',
        'disabled',
        'disagree',
        'disappear',
        'disappointed',
        'disappointment',
        'disaster',
        'discipline',
        'disclose',
        'discount',
        'discourage',
        'discourse',
        'discover',
        'discovery',
        'discrimination',
        'discuss',
        'discussion',
        'disease',
        'dismiss',
        'disorder',
        'display',
        'dispute',
        'dissolve',
        'distance',
        'distant',
        'distinct',
        'distinction',
        'distinctive',
        'distinguish',
        'distract',
        'distribute',
        'distribution',
        'district',
        'disturb',
        'disturbing',
        'diverse',
        'diversity',
        'divide',
        'divine',
        'division',
        'divorce',
        'doctor',
        'doctrine',
        'document',
        'documentary',
        'domain',
        'domestic',
        'dominant',
        'dominate',
        'donate',
        'donation',
        'doorway',
        'double',
        'downtown',
        'dramatic',
        'dramatically',
        'drawer',
        'drawing',
        'drinking',
        'driver',
        'driveway',
        'driving',
        'during',
        'dynamic',
        'dynamics',
        'e-mail',
        'earnings',
        'earthquake',
        'easily',
        'eastern',
        'eating',
        'ecological',
        'economic',
        'economically',
        'economics',
        'economist',
        'economy',
        'ecosystem',
        'edition',
        'editor',
        'educate',
        'education',
        'educational',
        'educator',
        'effect',
        'effective',
        'effectively',
        'effectiveness',
        'efficiency',
        'efficient',
        'effort',
        'eighth',
        'either',
        'elaborate',
        'elderly',
        'election',
        'electric',
        'electrical',
        'electricity',
        'electronic',
        'electronics',
        'elegant',
        'element',
        'elementary',
        'elephant',
        'elevator',
        'eleven',
        'eligible',
        'eliminate',
        'elsewhere',
        'embarrassed',
        'embrace',
        'emerge',
        'emergency',
        'emerging',
        'emission',
        'emotion',
        'emotional',
        'emotionally',
        'emphasis',
        'emphasize',
        'empire',
        'employ',
        'employee',
        'employer',
        'employment',
        'enable',
        'encounter',
        'encourage',
        'encouraging',
        'endless',
        'endorse',
        'endure',
        'energy',
        'enforce',
        'enforcement',
        'engage',
        'engagement',
        'engine',
        'engineer',
        'engineering',
        'enhance',
        'enormous',
        'enough',
        'enroll',
        'ensure',
        'enterprise',
        'entertainment',
        'enthusiasm',
        'entire',
        'entirely',
        'entitle',
        'entity',
        'entrance',
        'entrepreneur',
        'envelope',
        'environment',
        'environmental',
        'envision',
        'epidemic',
        'episode',
        'equality',
        'equally',
        'equation',
        'equipment',
        'equity',
        'equivalent',
        'escape',
        'especially',
        'essence',
        'essential',
        'essentially',
        'establish',
        'establishment',
        'estate',
        'estimate',
        'estimated',
        'ethical',
        'ethics',
        'ethnic',
        'evaluate',
        'evaluation',
        'evening',
        'eventually',
        'everybody',
        'everyday',
        'everyone',
        'everything',
        'everywhere',
        'evidence',
        'evident',
        'evolution',
        'evolve',
        'exactly',
        'examination',
        'examine',
        'example',
        'exceed',
        'excellent',
        'except',
        'exception',
        'excessive',
        'exchange',
        'excited',
        'excitement',
        'exciting',
        'exclude',
        'exclusive',
        'exclusively',
        'excuse',
        'execute',
        'execution',
        'executive',
        'exercise',
        'exhaust',
        'exhibit',
        'exhibition',
        'existence',
        'existing',
        'exotic',
        'expand',
        'expansion',
        'expect',
        'expectation',
        'expected',
        'expedition',
        'expense',
        'expensive',
        'experience',
        'experienced',
        'experiment',
        'experimental',
        'expert',
        'expertise',
        'explain',
        'explanation',
        'explicit',
        'explode',
        'exploit',
        'exploration',
        'explore',
        'explosion',
        'export',
        'expose',
        'exposure',
        'express',
        'expression',
        'extend',
        'extended',
        'extension',
        'extensive',
        'extent',
        'external',
        'extraordinary',
        'extreme',
        'extremely',
        'eyebrow',
        'fabric',
        'facilitate',
        'facility',
        'factor',
        'factory',
        'faculty',
        'failure',
        'fairly',
        'familiar',
        'family',
        'famous',
        'fantastic',
        'fantasy',
        'farmer',
        'fascinating',
        'fashion',
        'faster',
        'father',
        'fatigue',
        'favorable',
        'favorite',
        'feather',
        'feature',
        'federal',
        'feedback',
        'feeling',
        'fellow',
        'female',
        'feminist',
        'festival',
        'fiction',
        'fierce',
        'fifteen',
        'fighter',
        'fighting',
        'figure',
        'filter',
        'finally',
        'finance',
        'financial',
        'finding',
        'finger',
        'finish',
        'firmly',
        'fiscal',
        'fisherman',
        'fishing',
        'fitness',
        'flavor',
        'flexibility',
        'flexible',
        'flight',
        'flower',
        'flying',
        'follow',
        'following',
        'football',
        'forbid',
        'forehead',
        'foreign',
        'foreigner',
        'forest',
        'forever',
        'forget',
        'forgive',
        'formal',
        'format',
        'formation',
        'former',
        'formerly',
        'formula',
        'fortunately',
        'fortune',
        'forward',
        'foster',
        'foundation',
        'founder',
        'fourth',
        'fraction',
        'fragile',
        'fragment',
        'framework',
        'franchise',
        'frankly',
        'freedom',
        'freely',
        'freeze',
        'frequency',
        'frequent',
        'frequently',
        'freshman',
        'friend',
        'friendly',
        'friendship',
        'frontier',
        'frozen',
        'frustrate',
        'frustration',
        'fucking',
        'full-time',
        'function',
        'functional',
        'fundamental',
        'funding',
        'funeral',
        'furniture',
        'furthermore',
        'future',
        'galaxy',
        'gallery',
        'garage',
        'garbage',
        'garden',
        'garlic',
        'gasoline',
        'gather',
        'gathering',
        'gender',
        'general',
        'generally',
        'generate',
        'generation',
        'generous',
        'genetic',
        'genius',
        'gentle',
        'gentleman',
        'gently',
        'genuine',
        'gesture',
        'gifted',
        'girlfriend',
        'glance',
        'glimpse',
        'global',
        'golden',
        'govern',
        'government',
        'governor',
        'gradually',
        'graduate',
        'graduation',
        'grandchild',
        'grandfather',
        'grandmother',
        'grandparent',
        'grateful',
        'gravity',
        'greatest',
        'greatly',
        'grocery',
        'ground',
        'growing',
        'growth',
        'guarantee',
        'guidance',
        'guideline',
        'guilty',
        'guitar',
        'habitat',
        'halfway',
        'hallway',
        'handful',
        'handle',
        'handsome',
        'happen',
        'happily',
        'happiness',
        'harassment',
        'hardly',
        'hardware',
        'harmony',
        'harvest',
        'hazard',
        'headache',
        'headline',
        'headquarters',
        'health',
        'health-care',
        'healthy',
        'hearing',
        'heaven',
        'heavily',
        'height',
        'helicopter',
        'helmet',
        'helpful',
        'heritage',
        'herself',
        'hesitate',
        'hidden',
        'high-tech',
        'highlight',
        'highly',
        'highway',
        'himself',
        'historian',
        'historic',
        'historical',
        'historically',
        'history',
        'hockey',
        'holiday',
        'homeland',
        'homeless',
        'homework',
        'honest',
        'honestly',
        'hopefully',
        'horizon',
        'hormone',
        'horrible',
        'horror',
        'hospital',
        'hostage',
        'hostile',
        'household',
        'housing',
        'however',
        'humanity',
        'hundred',
        'hunger',
        'hungry',
        'hunter',
        'hunting',
        'hurricane',
        'husband',
        'hypothesis',
        'identical',
        'identification',
        'identify',
        'identity',
        'ideological',
        'ideology',
        'ignore',
        'illegal',
        'illness',
        'illusion',
        'illustrate',
        'imagination',
        'imagine',
        'immediate',
        'immediately',
        'immigrant',
        'immigration',
        'immune',
        'impact',
        'implement',
        'implementation',
        'implication',
        'import',
        'importance',
        'important',
        'importantly',
        'impose',
        'impossible',
        'impress',
        'impression',
        'impressive',
        'improve',
        'improved',
        'improvement',
        'impulse',
        'incentive',
        'incident',
        'include',
        'including',
        'income',
        'incorporate',
        'increase',
        'increased',
        'increasing',
        'increasingly',
        'incredible',
        'incredibly',
        'indeed',
        'independence',
        'independent',
        'indicate',
        'indication',
        'indicator',
        'indigenous',
        'individual',
        'industrial',
        'industry',
        'inevitable',
        'inevitably',
        'infant',
        'infection',
        'inflation',
        'influence',
        'influential',
        'inform',
        'informal',
        'information',
        'infrastructure',
        'ingredient',
        'inherent',
        'inherit',
        'initial',
        'initially',
        'initiate',
        'initiative',
        'injure',
        'injury',
        'inmate',
        'innocent',
        'innovation',
        'innovative',
        'inquiry',
        'insect',
        'insert',
        'inside',
        'insight',
        'insist',
        'inspection',
        'inspector',
        'inspiration',
        'inspire',
        'install',
        'installation',
        'instance',
        'instant',
        'instantly',
        'instead',
        'instinct',
        'institution',
        'institutional',
        'instruct',
        'instruction',
        'instructional',
        'instructor',
        'instrument',
        'insurance',
        'intact',
        'integrate',
        'integrated',
        'integration',
        'integrity',
        'intellectual',
        'intelligence',
        'intelligent',
        'intend',
        'intense',
        'intensity',
        'intent',
        'intention',
        'interact',
        'interaction',
        'interest',
        'interested',
        'interesting',
        'interfere',
        'interior',
        'internal',
        'international',
        'interpret',
        'interpretation',
        'interrupt',
        'interval',
        'intervention',
        'interview',
        'intimate',
        'introduce',
        'introduction',
        'invade',
        'invasion',
        'invent',
        'invention',
        'inventory',
        'invest',
        'investigate',
        'investigation',
        'investigator',
        'investment',
        'investor',
        'invisible',
        'invitation',
        'invite',
        'involve',
        'involved',
        'involvement',
        'ironically',
        'island',
        'isolate',
        'isolated',
        'isolation',
        'itself',
        'jacket',
        'jewelry',
        'journal',
        'journalism',
        'journalist',
        'journey',
        'judgment',
        'judicial',
        'jungle',
        'junior',
        'jurisdiction',
        'justice',
        'justify',
        'killer',
        'killing',
        'kingdom',
        'kitchen',
        'knowledge',
        'laboratory',
        'ladder',
        'landing',
        'landmark',
        'landscape',
        'language',
        'largely',
        'lately',
        'latter',
        'laughter',
        'launch',
        'lawmaker',
        'lawsuit',
        'lawyer',
        'leader',
        'leadership',
        'leading',
        'league',
        'learning',
        'leather',
        'lecture',
        'legacy',
        'legally',
        'legend',
        'legislation',
        'legislative',
        'legislator',
        'legislature',
        'legitimate',
        'length',
        'lesson',
        'letter',
        'liability',
        'liberal',
        'liberty',
        'library',
        'license',
        'lifestyle',
        'lifetime',
        'lighting',
        'lightly',
        'lightning',
        'likelihood',
        'likely',
        'likewise',
        'limitation',
        'limited',
        'liquid',
        'listen',
        'listener',
        'literally',
        'literary',
        'literature',
        'little',
        'living',
        'locate',
        'location',
        'logical',
        'lonely',
        'long-term',
        'longtime',
        'lovely',
        'loyalty',
        'machine',
        'magazine',
        'magnetic',
        'magnitude',
        'mainly',
        'mainstream',
        'maintain',
        'maintenance',
        'majority',
        'makeup',
        'manage',
        'management',
        'manager',
        'managing',
        'mandate',
        'manipulate',
        'manner',
        'mansion',
        'manufacturer',
        'manufacturing',
        'marble',
        'margin',
        'marine',
        'marker',
        'market',
        'marketing',
        'marketplace',
        'marriage',
        'married',
        'massive',
        'master',
        'material',
        'mathematics',
        'matter',
        'maximum',
        'meaning',
        'meaningful',
        'meantime',
        'meanwhile',
        'measure',
        'measurement',
        'mechanic',
        'mechanical',
        'mechanism',
        'medical',
        'medication',
        'medicine',
        'medium',
        'meeting',
        'member',
        'membership',
        'memory',
        'mental',
        'mentally',
        'mention',
        'mentor',
        'merchant',
        'merely',
        'message',
        'metaphor',
        'method',
        'metropolitan',
        'middle',
        'midnight',
        'migration',
        'military',
        'million',
        'mineral',
        'minimal',
        'minimize',
        'minimum',
        'minister',
        'ministry',
        'minority',
        'minute',
        'miracle',
        'mirror',
        'missile',
        'missing',
        'mission',
        'missionary',
        'mistake',
        'mixture',
        'mm-hmm',
        'mobile',
        'moderate',
        'modern',
        'modest',
        'modify',
        'molecule',
        'moment',
        'momentum',
        'monitor',
        'monkey',
        'monster',
        'monthly',
        'monument',
        'moreover',
        'morning',
        'mortality',
        'mortgage',
        'mostly',
        'mother',
        'motion',
        'motivate',
        'motivation',
        'motive',
        'mountain',
        'movement',
        'multiple',
        'municipal',
        'murder',
        'muscle',
        'museum',
        'mushroom',
        'musical',
        'musician',
        'mutter',
        'mutual',
        'myself',
        'mysterious',
        'mystery',
        'narrative',
        'narrow',
        'nation',
        'national',
        'nationwide',
        'native',
        'natural',
        'naturally',
        'nature',
        'nearby',
        'nearly',
        'necessarily',
        'necessary',
        'necessity',
        'needle',
        'negative',
        'negotiate',
        'negotiation',
        'neighbor',
        'neighborhood',
        'neighboring',
        'neither',
        'nervous',
        'network',
        'neutral',
        'nevertheless',
        'newspaper',
        'nightmare',
        'nobody',
        'nomination',
        'nominee',
        'nonetheless',
        'nonprofit',
        'normal',
        'normally',
        'northeast',
        'northern',
        'northwest',
        'notebook',
        'nothing',
        'notice',
        'notion',
        'nowhere',
        'nuclear',
        'number',
        'numerous',
        'nutrient',
        "o'clock",
        'object',
        'objection',
        'objective',
        'obligation',
        'observation',
        'observe',
        'observer',
        'obstacle',
        'obtain',
        'obvious',
        'obviously',
        'occasion',
        'occasional',
        'occasionally',
        'occupation',
        'occupy',
        'offender',
        'offense',
        'offensive',
        'offering',
        'office',
        'officer',
        'official',
        'officially',
        'old-fashioned',
        'one-third',
        'ongoing',
        'online',
        'opening',
        'openly',
        'operate',
        'operating',
        'operation',
        'operator',
        'opinion',
        'opponent',
        'opportunity',
        'oppose',
        'opposed',
        'opposite',
        'opposition',
        'optimistic',
        'option',
        'orange',
        'ordinary',
        'organic',
        'organism',
        'organization',
        'organizational',
        'organize',
        'organized',
        'orientation',
        'origin',
        'original',
        'originally',
        'others',
        'otherwise',
        'ourselves',
        'outcome',
        'outdoor',
        'outfit',
        'outlet',
        'outline',
        'output',
        'outside',
        'outsider',
        'outstanding',
        'overall',
        'overcome',
        'overlook',
        'overnight',
        'oversee',
        'overwhelm',
        'overwhelming',
        'ownership',
        'oxygen',
        'package',
        'painful',
        'painter',
        'painting',
        'palace',
        'parade',
        'parent',
        'parental',
        'parish',
        'parking',
        'partial',
        'partially',
        'participant',
        'participate',
        'participation',
        'particle',
        'particular',
        'particularly',
        'partly',
        'partner',
        'partnership',
        'passage',
        'passenger',
        'passing',
        'passion',
        'password',
        'pastor',
        'patent',
        'patience',
        'patient',
        'patrol',
        'patron',
        'pattern',
        'payment',
        'peaceful',
        'peanut',
        'peasant',
        'penalty',
        'pencil',
        'pension',
        'people',
        'pepper',
        'perceive',
        'perceived',
        'percentage',
        'perception',
        'perfect',
        'perfectly',
        'perform',
        'performance',
        'performer',
        'perhaps',
        'period',
        'permanent',
        'permission',
        'permit',
        'persist',
        'person',
        'personal',
        'personality',
        'personally',
        'personnel',
        'perspective',
        'persuade',
        'phenomenon',
        'philosophical',
        'philosophy',
        'photograph',
        'photographer',
        'photography',
        'phrase',
        'physical',
        'physically',
        'physician',
        'physics',
        'pickup',
        'picture',
        'pillow',
        'pioneer',
        'pitcher',
        'placement',
        'planet',
        'planner',
        'planning',
        'plastic',
        'platform',
        'player',
        'playoff',
        'pleasant',
        'please',
        'pleased',
        'pleasure',
        'plenty',
        'plunge',
        'pocket',
        'poetry',
        'police',
        'policeman',
        'policy',
        'political',
        'politically',
        'politician',
        'politics',
        'pollution',
        'popular',
        'popularity',
        'population',
        'portfolio',
        'portion',
        'portrait',
        'portray',
        'position',
        'positive',
        'possess',
        'possession',
        'possibility',
        'possible',
        'possibly',
        'poster',
        'potato',
        'potential',
        'potentially',
        'poverty',
        'powder',
        'powerful',
        'practical',
        'practically',
        'practice',
        'practitioner',
        'praise',
        'prayer',
        'preach',
        'precious',
        'precise',
        'precisely',
        'predator',
        'predict',
        'prediction',
        'prefer',
        'preference',
        'pregnancy',
        'pregnant',
        'preliminary',
        'premise',
        'premium',
        'preparation',
        'prepare',
        'prescription',
        'presence',
        'present',
        'presentation',
        'preserve',
        'presidency',
        'president',
        'presidential',
        'pressure',
        'presumably',
        'pretend',
        'pretty',
        'prevail',
        'prevent',
        'prevention',
        'previous',
        'previously',
        'priest',
        'primarily',
        'primary',
        'principal',
        'principle',
        'priority',
        'prison',
        'prisoner',
        'privacy',
        'private',
        'privately',
        'privilege',
        'probably',
        'problem',
        'procedure',
        'proceed',
        'process',
        'processing',
        'processor',
        'proclaim',
        'produce',
        'producer',
        'product',
        'production',
        'productive',
        'productivity',
        'profession',
        'professional',
        'professor',
        'profile',
        'profit',
        'profound',
        'program',
        'programming',
        'progress',
        'progressive',
        'prohibit',
        'project',
        'projection',
        'prominent',
        'promise',
        'promising',
        'promote',
        'promotion',
        'prompt',
        'proper',
        'properly',
        'property',
        'proportion',
        'proposal',
        'propose',
        'proposed',
        'prosecution',
        'prosecutor',
        'prospect',
        'protect',
        'protection',
        'protective',
        'protein',
        'protest',
        'protocol',
        'provide',
        'provided',
        'provider',
        'province',
        'provision',
        'provoke',
        'psychological',
        'psychologist',
        'psychology',
        'public',
        'publication',
        'publicity',
        'publicly',
        'publish',
        'publisher',
        'punish',
        'punishment',
        'purchase',
        'purple',
        'purpose',
        'pursue',
        'pursuit',
        'puzzle',
        'qualify',
        'quality',
        'quantity',
        'quarter',
        'quarterback',
        'question',
        'questionnaire',
        'quickly',
        'quietly',
        'rabbit',
        'racial',
        'racism',
        'radiation',
        'radical',
        'railroad',
        'random',
        'rapidly',
        'rarely',
        'rather',
        'rating',
        'rational',
        'reaction',
        'reader',
        'readily',
        'reading',
        'realistic',
        'reality',
        'realize',
        'really',
        'reason',
        'reasonable',
        'rebuild',
        'recall',
        'receive',
        'receiver',
        'recent',
        'recently',
        'reception',
        'recession',
        'recipe',
        'recipient',
        'recognition',
        'recognize',
        'recommend',
        'recommendation',
        'record',
        'recording',
        'recover',
        'recovery',
        'recruit',
        'reduce',
        'reduction',
        'reference',
        'reflect',
        'reflection',
        'reform',
        'refrigerator',
        'refuge',
        'refugee',
        'refuse',
        'regain',
        'regard',
        'regarding',
        'regardless',
        'regime',
        'region',
        'regional',
        'register',
        'regret',
        'regular',
        'regularly',
        'regulate',
        'regulation',
        'regulator',
        'regulatory',
        'rehabilitation',
        'reinforce',
        'reject',
        'relate',
        'related',
        'relation',
        'relationship',
        'relative',
        'relatively',
        'release',
        'relevant',
        'reliability',
        'reliable',
        'relief',
        'relieve',
        'religion',
        'religious',
        'reluctant',
        'remain',
        'remaining',
        'remark',
        'remarkable',
        'remember',
        'remind',
        'reminder',
        'remote',
        'removal',
        'remove',
        'render',
        'rental',
        'repair',
        'repeat',
        'repeatedly',
        'replace',
        'replacement',
        'report',
        'reportedly',
        'reporter',
        'reporting',
        'represent',
        'representation',
        'representative',
        'republic',
        'republican',
        'reputation',
        'request',
        'require',
        'required',
        'requirement',
        'rescue',
        'research',
        'researcher',
        'resemble',
        'reservation',
        'reserve',
        'residence',
        'resident',
        'residential',
        'resign',
        'resist',
        'resistance',
        'resolution',
        'resolve',
        'resort',
        'resource',
        'respect',
        'respectively',
        'respond',
        'respondent',
        'response',
        'responsibility',
        'responsible',
        'restaurant',
        'restore',
        'restrict',
        'restriction',
        'result',
        'resume',
        'retail',
        'retailer',
        'retain',
        'retire',
        'retired',
        'retirement',
        'retreat',
        'return',
        'reveal',
        'revelation',
        'revenue',
        'reverse',
        'review',
        'revolution',
        'revolutionary',
        'reward',
        'rhetoric',
        'rhythm',
        'ribbon',
        'ridiculous',
        'ritual',
        'rocket',
        'rolling',
        'romance',
        'romantic',
        'roughly',
        'routine',
        'routinely',
        'rubber',
        'ruling',
        'runner',
        'running',
        'sacred',
        'sacrifice',
        'safely',
        'safety',
        'salary',
        'salmon',
        'sample',
        'sanction',
        'sandwich',
        'satellite',
        'satisfaction',
        'satisfy',
        'saving',
        'scandal',
        'scared',
        'scatter',
        'scenario',
        'schedule',
        'scheme',
        'scholar',
        'scholarship',
        'school',
        'science',
        'scientific',
        'scientist',
        'scramble',
        'scratch',
        'scream',
        'screen',
        'screening',
        'script',
        'sculpture',
        'search',
        'season',
        'second',
        'secondary',
        'secret',
        'secretary',
        'section',
        'sector',
        'secular',
        'secure',
        'security',
        'seemingly',
        'segment',
        'seldom',
        'select',
        'selected',
        'selection',
        'self-esteem',
        'seller',
        'seminar',
        'senator',
        'senior',
        'sensation',
        'sensitive',
        'sensitivity',
        'sentence',
        'sentiment',
        'separate',
        'separation',
        'sequence',
        'series',
        'serious',
        'seriously',
        'servant',
        'service',
        'serving',
        'session',
        'setting',
        'settle',
        'settlement',
        'seventh',
        'several',
        'severe',
        'severely',
        'sexual',
        'sexuality',
        'sexually',
        'shadow',
        'shallow',
        'shared',
        'shareholder',
        'sharply',
        'shelter',
        'shooting',
        'shopping',
        'short-term',
        'shortage',
        'shortly',
        'shorts',
        'should',
        'shoulder',
        'shower',
        'shrimp',
        'shrink',
        'shuttle',
        'sibling',
        'sidewalk',
        'signal',
        'signature',
        'significance',
        'significant',
        'significantly',
        'silence',
        'silent',
        'silver',
        'similar',
        'similarity',
        'similarly',
        'simple',
        'simply',
        'simultaneously',
        'singer',
        'single',
        'sister',
        'situation',
        'skilled',
        'slavery',
        'sleeve',
        'slight',
        'slightly',
        'slowly',
        'smooth',
        'so-called',
        'soccer',
        'social',
        'socially',
        'society',
        'sodium',
        'soften',
        'softly',
        'software',
        'soldier',
        'solely',
        'solution',
        'somebody',
        'someday',
        'somehow',
        'someone',
        'something',
        'sometime',
        'sometimes',
        'somewhat',
        'somewhere',
        'sophisticated',
        'source',
        'southeast',
        'southern',
        'southwest',
        'sovereignty',
        'speaker',
        'special',
        'specialist',
        'specialize',
        'specialty',
        'species',
        'specific',
        'specifically',
        'specify',
        'spectacular',
        'spectrum',
        'speculate',
        'speculation',
        'speech',
        'spending',
        'sphere',
        'spirit',
        'spiritual',
        'spokesman',
        'sponsor',
        'spouse',
        'spread',
        'spring',
        'sprinkle',
        'square',
        'squeeze',
        'stability',
        'stable',
        'stadium',
        'stance',
        'standard',
        'standing',
        'starter',
        'starting',
        'statement',
        'station',
        'statistical',
        'statistics',
        'statue',
        'status',
        'statute',
        'steadily',
        'steady',
        'stimulate',
        'stimulus',
        'stomach',
        'storage',
        'straight',
        'straighten',
        'strain',
        'strange',
        'stranger',
        'strategic',
        'strategy',
        'streak',
        'stream',
        'street',
        'strength',
        'strengthen',
        'stress',
        'stretch',
        'strict',
        'strictly',
        'strike',
        'striking',
        'string',
        'stroke',
        'strong',
        'strongly',
        'structural',
        'structure',
        'struggle',
        'student',
        'studio',
        'stumble',
        'stupid',
        'subject',
        'submit',
        'subsequent',
        'subsidy',
        'substance',
        'substantial',
        'substantially',
        'subtle',
        'suburb',
        'suburban',
        'succeed',
        'success',
        'successful',
        'successfully',
        'sudden',
        'suddenly',
        'suffer',
        'suffering',
        'sufficient',
        'suggest',
        'suggestion',
        'suicide',
        'suitable',
        'summary',
        'summer',
        'summit',
        'sunlight',
        'superior',
        'supermarket',
        'supervisor',
        'supplier',
        'supply',
        'support',
        'supporter',
        'supportive',
        'suppose',
        'supposed',
        'supposedly',
        'surely',
        'surface',
        'surgeon',
        'surgery',
        'surprise',
        'surprised',
        'surprising',
        'surprisingly',
        'surround',
        'surrounding',
        'surveillance',
        'survey',
        'survival',
        'survive',
        'survivor',
        'suspect',
        'suspend',
        'suspicion',
        'suspicious',
        'sustain',
        'sustainable',
        'swallow',
        'sweater',
        'swimming',
        'switch',
        'symbol',
        'symbolic',
        'sympathy',
        'symptom',
        'syndrome',
        'system',
        'tablespoon',
        'tackle',
        'tactic',
        'talent',
        'talented',
        'target',
        'taxpayer',
        'teacher',
        'teaching',
        'teammate',
        'teaspoon',
        'technical',
        'technician',
        'technique',
        'technological',
        'technology',
        'teenage',
        'teenager',
        'telephone',
        'telescope',
        'television',
        'temperature',
        'temple',
        'temporary',
        'tendency',
        'tender',
        'tennis',
        'tension',
        'terrain',
        'terrible',
        'terribly',
        'terrific',
        'territory',
        'terror',
        'terrorism',
        'terrorist',
        'testify',
        'testimony',
        'testing',
        'textbook',
        'texture',
        'thanks',
        'theater',
        'themselves',
        'theological',
        'theology',
        'theoretical',
        'theory',
        'therapist',
        'therapy',
        'thereby',
        'therefore',
        'thinking',
        'thirty',
        'thoroughly',
        'though',
        'thought',
        'thousand',
        'thread',
        'threat',
        'threaten',
        'threshold',
        'thrive',
        'throat',
        'through',
        'throughout',
        'ticket',
        'tighten',
        'tightly',
        'timber',
        'timing',
        'tissue',
        'tobacco',
        'together',
        'toilet',
        'tolerance',
        'tolerate',
        'tomato',
        'tomorrow',
        'tongue',
        'tonight',
        'totally',
        'touchdown',
        'tourism',
        'tourist',
        'tournament',
        'toward',
        'towards',
        'trading',
        'tradition',
        'traditional',
        'traditionally',
        'traffic',
        'tragedy',
        'tragic',
        'trailer',
        'trainer',
        'training',
        'transaction',
        'transfer',
        'transform',
        'transformation',
        'transit',
        'transition',
        'translate',
        'translation',
        'transmission',
        'transmit',
        'transport',
        'transportation',
        'trauma',
        'travel',
        'traveler',
        'treasure',
        'treatment',
        'treaty',
        'tremendous',
        'tribal',
        'trigger',
        'triumph',
        'tropical',
        'trouble',
        'troubled',
        'tunnel',
        'turkey',
        'twelve',
        'twentieth',
        'twenty',
        'two-thirds',
        'typical',
        'typically',
        'ultimate',
        'ultimately',
        'unable',
        'uncertain',
        'uncertainty',
        'uncomfortable',
        'uncover',
        'undergo',
        'undergraduate',
        'underlying',
        'undermine',
        'understand',
        'understanding',
        'undertake',
        'unemployment',
        'unexpected',
        'unfair',
        'unfold',
        'unfortunately',
        'unhappy',
        'uniform',
        'unique',
        'universal',
        'universe',
        'university',
        'unknown',
        'unless',
        'unlike',
        'unlikely',
        'unprecedented',
        'unusual',
        'update',
        'upstairs',
        'useful',
        'usually',
        'utility',
        'utilize',
        'vacation',
        'vaccine',
        'vacuum',
        'validity',
        'valley',
        'valuable',
        'vanish',
        'variable',
        'variation',
        'variety',
        'various',
        'vegetable',
        'vehicle',
        'vendor',
        'venture',
        'verbal',
        'verdict',
        'version',
        'versus',
        'vertical',
        'vessel',
        'vestwell',
        'veteran',
        'victim',
        'victory',
        'viewer',
        'village',
        'violate',
        'violation',
        'violence',
        'violent',
        'virtual',
        'virtually',
        'virtue',
        'visible',
        'vision',
        'visitor',
        'visual',
        'vitamin',
        'volume',
        'voluntary',
        'volunteer',
        'voting',
        'vulnerable',
        'walking',
        'wander',
        'warehouse',
        'warmth',
        'warning',
        'warrior',
        'weaken',
        'weakness',
        'wealth',
        'wealthy',
        'weapon',
        'weather',
        'wedding',
        'weekend',
        'weekly',
        'weight',
        'welcome',
        'welfare',
        'well-being',
        'well-known',
        'western',
        'whatever',
        'wheelchair',
        'whenever',
        'whereas',
        'wherever',
        'whether',
        'whisper',
        'whoever',
        'widely',
        'widespread',
        'wilderness',
        'wildlife',
        'willing',
        'willingness',
        'window',
        'winner',
        'winter',
        'wisdom',
        'withdraw',
        'withdrawal',
        'within',
        'without',
        'witness',
        'wonder',
        'wonderful',
        'wooden',
        'worker',
        'working',
        'workout',
        'workplace',
        'workshop',
        'worldwide',
        'worried',
        'writer',
        'writing',
        'written',
        'yellow',
        'yesterday',
        'youngster',
        'yourself'
    ]
};
export const validatePassword = (contextWords = [], { minLength = DEFAULT_PASSWORD_MIN_LENGTH } = {})=>{
    const context = contextWords.reduce((acc, word)=>[
            ...acc,
            ...word.split('@')[0].split(/[-!$%^&*()_+|~=`{}[\]:/;<>?,.@#]/).filter(Boolean).filter((p)=>p.length > (word.includes('@') ? 4 : 5))
        ], []);
    return z.string({
        required_error: passwordErrorMsg.required
    }).min(minLength, {
        message: passwordErrorMsg.minLength(minLength)
    }).refine((value)=>!/([a-zA-Z0-9])\1{3,}/.test(value) && !invalidPasswords.alphaRepeats.some((chars)=>value.toLowerCase().includes(chars)) && !invalidPasswords.numRepeats.some((chars)=>value.includes(chars)), {
        message: passwordErrorMsg.repeatingChars
    }).refine((value)=>/[0-9]/.test(value), {
        message: passwordErrorMsg.oneNumber
    }).refine((value)=>/[!|@|#|$|%|^|&|*|(|)|:|}|{|+|-|_]/.test(value), {
        message: passwordErrorMsg.oneSpecialCharacter
    }).refine((value)=>!invalidPasswords.obvious.some((chars)=>value.toLowerCase().includes(chars)), {
        message: passwordErrorMsg.obvious
    }).refine((value)=>!context.some((word)=>value.toLowerCase().includes(word)), {
        message: passwordErrorMsg.contextSpecific
    });
};

//# sourceMappingURL=validatePassword.js.map